letterAdjust.scale = 0.8;
// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
var font = {
    "0": "M0 132v803l129 130h309l130 -130v-803l-130 -132h-309zM183 185h201v696h-201v-696z",
    "1": "M0 0v185h76v614h-76v136l101 130h160v-880h74v-185h-335z",
    "2": "M0 0v399l384 337v145h-200v-104h-184v158l129 130h309l130 -130v-282l-384 -338v-130h200v102h184v-287h-568z",
    "3": "M0 132v155h183v-102h202v256h-126v184h126v256h-202v-104h-183v158l129 130h309l130 -130v-337l-65 -66l65 -63v-337l-130 -132h-309z",
    "4": "M0 287v203l289 575h205v-591h74v-187h-74v-102h74v-185h-335v185h77v102h-310zM198 474h112v221z",
    "5": "M0 132v157h184v-104h200v256h-255l-129 130v494h568v-184h-384v-255h254l130 -131v-363l-130 -132h-309z",
    "6": "M0 132v803l132 130h307l131 -130v-158h-184v104h-201v-255h254l131 -131v-363l-131 -132h-307zM185 185h201v256h-201v-256z",
    "7": "M0 777v288h570v-237l-179 -643h72v-185h-346v185h83l193 696h-209v-104h-184z",
    "8": "M0 132v337l64 65l-64 64v337l131 130h307l129 -130v-337l-64 -64l64 -65v-337l-129 -132h-307zM184 185h200v256h-200v-256zM184 626h200v255h-200v-255z",
    "9": "M0 131v156h183v-102h201v256h-255l-129 130v364l129 130h308l131 -130v-804l-131 -131h-308zM183 625h201v255h-201v-255z",
    "A": "M0 0h207l14 71h189l14 -71h206l-213 1065h-205zM261 273l52 269l57 -269h-109z",
    "B": "M0 0h452l169 169v296l-67 67l67 69v295l-169 169h-452v-1065zM202 202v230h165l50 -50v-130l-50 -50h-165zM202 634v229h165l50 -50v-127l-50 -52h-165z",
    "C": "M0 169l169 -169h283l169 169v165h-202v-82l-49 -50h-118l-50 50v561l50 50h118l49 -50v-82h202v165l-169 169h-283l-169 -169v-727z",
    "D": "M0 0h452l169 169v727l-169 169h-452v-1065zM202 202v661h168l49 -50v-561l-49 -50h-168z",
    "E": "M0 0h621v202h-419v230h217v202h-217v229h419v202h-621v-1065z",
    "F": "M0 0h202v432h213v202h-213v229h416v202h-618v-1065z",
    "G": "M0 169l169 -169h283l169 169v387h-339v-203h137v-101l-52 -50h-115l-50 50v561l50 50h115l52 -50v-82h202v165l-169 169h-283l-169 -169v-727z",
    "H": "M0 0h202v432h215v-432h204v1065h-204v-431h-215v431h-202v-1065z",
    "I": "M0 0h202v1065h-202v-1065z",
    "J": "M0 169l165 -169h282l171 169v896h-203v-813l-50 -50h-115l-50 50v82h-200v-165z",
    "K": "M0 0h205v356l89 155l121 -511h206l-178 763l178 302h-235l-181 -312v312h-205v-1065z",
    "L": "M0 0h621v202h-419v863h-202v-1065z",
    "M": "M0 0h205v426l106 -318l108 318v-426h202v1065h-197l-113 -327l-111 327h-200v-1065z",
    "N": "M0 0h202v530l222 -530h197v1065h-202v-530l-221 530h-198v-1065z",
    "O": "M0 169l169 -169h283l169 169v727l-169 169h-283l-169 -169v-727zM202 252v561l50 50h118l49 -50v-561l-49 -50h-118z",
    "P": "M0 0h202v432h250l169 169v295l-169 169h-452v-1065zM202 634v229h165l52 -50v-127l-52 -52h-165z",
    "Q": "M0 172l169 -172h159l81 -85h149l-95 95l157 162v724l-169 169h-282l-169 -169v-724zM202 253v560l50 50h117l49 -50v-560l-49 -51h-117z",
    "R": "M0 0h200v432h76l129 -432h213l-140 460l140 141v295l-171 169h-447v-1065zM200 634v229h165l50 -50v-127l-50 -52h-165z",
    "S": "M0 169l168 -169h282l168 169v296l-168 169h-198l-50 52v127l50 50h115l50 -50v-82h201v165l-168 169h-282l-168 -169v-295l168 -169h199l50 -50v-130l-50 -50h-115l-50 50v82h-202v-165z",
    "T": "M0 863h211v-863h202v863h208v202h-621v-202z",
    "U": "M0 169l169 -169h283l169 169v896h-202v-813l-49 -50h-118l-50 50v813h-202v-896z",
    "V": "M0 1065l200 -1065h222l199 1065h-204l-106 -557l-104 557h-207z",
    "W": "M0 1065l99 -1065h205l101 386l102 -386h205l99 1065h-203l-45 -481l-127 481h-62l-126 -481l-46 481h-202z",
    "X": "M0 0h217l94 248l94 -248h216l-202 532l202 533h-216l-94 -248l-94 248h-217l202 -533z",
    "Y": "M0 1065l207 -667v-398h203v395l208 670h-208l-99 -313l-99 313h-212z",
    "Z": "M0 200l52 -200h532l37 202h-386l384 663l-49 200h-533l-37 -202h384z"
};

    font_size = 24,
    tracking = 1,
    panel_Hor_Adjustment = 2,
    font_Top_Adjustment = -16.5,
    middleSpreadAdjustment = {
        left: 0.5,
        right: 0.5
    },
    small_Caps_Adjustment = {
        vertical: -215,
        horizontal: 0,
        scale_width: 0, // effects period
        scale_height: 0, // effects period
    },
    colors = {
        characters: {
            home: [
                "#231f20", // black
            ],
            away: [
                "#ffffff", // white
            ]
        },
        numbers: {
            home: [
                "#ffffff", // white
                "#231f20", // black
            ],
            away: [
                "#d1673a", // orange
                "#231f20", // black
            ]
        }
    },
    outlines = {
        characters: {
            width: 0
        },
        numbers: {
            width: 3
        }
    },
    special_Character_Adjustments = {
        period: {
            vertical: 3.5, // this moves it up from the bottom
            horizontal: 3,
            scale_width: 12.5,
            scale_height: 12.5,
        },
        hyphen: {
            vertical: -6,
            horizontal: -5.5,
            scale_width: 0,
            scale_height: -3,
        },
        apostrophe: {
            vertical: 0.25, // this is backwards
            horizontal: -1,
            scale_width: 0,
            scale_height: 0,
        }
    },
    number_Adjustments = {
        top: 13,
        left: -3.5,
        width: 110,
        height: 90,
        middle_Space: 5,
        oneOffset: 6
    };
